import Footer from "../components/Footer/Footer";
import Aboutcomp from '../components/About/AboutComp.jsx'

export default function About () {
  return (
    <>
      <Aboutcomp />
      <Footer />
    </>
  )
}